import { Col, Row } from "antd";
import CustomSegment from "../../../../components/ui/CustomSegment";
import Loader from "../../../../components/ui/Loader";
import { useGetPayrollBatchSummaryQuery } from "../../../../features/organization/contractual/Payroll/payrollApi";
import useError from "../../../../hooks/useError";
import { useSegment } from "../../../../hooks/useSegment";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { SegmentedType } from "../../../../types";
import { addCommaInNumber } from "../../../../utils/number";
import KPIBatches from "./_components/KPIBatches";
import PayrollBatches from "./_components/PayrollBatches";
import DisbursementIcon from "./_icons/DisbursementIcon";
import EmployeesIcon from "./_icons/EmployeesIcon";
import PayoutIcon from "./_icons/PayoutIcon";
import PendingPayoutIcon from "./_icons/PendingPayoutIcon";

type SegmentType = "tab-1" | "tab-2";

const PayrollList = () => {
  const { segment, setSegment } = useSegment<SegmentType>(
    "payroll-segment",
    "tab-1",
    false
  );

  // ----- Query Config -----
  const { data, isError, error, isLoading, isFetching } =
    useGetPayrollBatchSummaryQuery({});

  // ----- Error Handling -----
  useError(isError, error, "Payroll Batch Summary Data Failed");

  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      key: "tab-1",
      label: "Generated Batches",
      element: <KPIBatches />,
    },
    {
      key: "tab-2",
      label: "Process Payroll",
      element: <PayrollBatches />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.key === segment);

  const payoutData = [
    {
      title: "Total Payout",
      amount: `৳ ${addCommaInNumber(data?.data?.total_payout || 0)}`,
      icon: <PayoutIcon />,
    },
    {
      title: "Pending Payout",
      amount: `৳ ${addCommaInNumber(data?.data?.pending_payout || 0)}`,
      icon: <PendingPayoutIcon />,
    },
    {
      title: "Pending Disbursement",
      amount: `৳ ${addCommaInNumber(data?.data?.pending_disbursement || 0)}`,
      icon: <DisbursementIcon />,
    },
    {
      title: "Total Employees",
      amount: `${addCommaInNumber(data?.data?.total_employees || 0)}`,
      icon: <EmployeesIcon />,
    },
  ];

  return (
    <SidebarLayout title="Payroll">
      {isLoading || isFetching ? (
        <Loader />
      ) : (
        <div>
          <Row gutter={[16, 16]} className="mb-5">
            {payoutData.map((item, index) => (
              <Col
                key={index}
                xs={12} // small screen: 2 columns per row
                sm={12}
                md={6} // medium & large: 4 columns per row
                lg={6}
                xl={6}
              >
                <div className="w-full p-4 bg-white rounded-lg outline outline-1 outline-offset-[-1px] outline-zinc-200 inline-flex flex-col justify-start items-start gap-2">
                  <div className="inline-flex justify-start items-center gap-2.5">
                    <div className="flex justify-start items-center">
                      {item.icon}
                    </div>

                    <div className=" justify-start text-slate-600 !text-[15px] font-normal">
                      {" "}
                      {item.title}
                    </div>
                  </div>
                  <div className="inline-flex justify-start items-center gap-2">
                    <div className="justify-start text-zinc-700 text-3xl font-normal">
                      {item.amount}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <CustomSegment
            config={SEGMENT_CONFIG}
            selected={segment}
            onChange={setSegment}
            className="mt-0 mx-0  border-b border-b-light"
          />
          <div className="mt-5">{currentSegment?.element}</div>
        </div>
      )}
    </SidebarLayout>
  );
};

export default PayrollList;
